/**
 * Maps
 */
const dealersMap = (containerId, lat, lng, pointsArray) => {

    const init = function init() {

        var map = new google.maps.Map(document.getElementById(containerId), {
            zoom: 6,
            disableDefaultUI: true,
            center: new google.maps.LatLng(lat, lng),
            styles: [
                {
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        }
                    ]
                },
                {
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#616161"
                        }
                    ]
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        }
                    ]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#bdbdbd"
                        },
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape.man_made",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "weight": 3.5
                        }
                    ]
                },
                {
                    "featureType": "landscape.man_made",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#eeeeee"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#757575"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e5e5e5"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#757575"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#dadada"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#616161"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                },
                {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e5e5e5"
                        }
                    ]
                },
                {
                    "featureType": "transit.station",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#eeeeee"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#c9c9c9"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                }
            ]
        });

        var infowindow = new google.maps.InfoWindow();

        var marker, i, markerUrl;

        for (i = 0; i < pointsArray.length; i++) {
            if(pointsArray[i][0]){
                markerUrl = pointsArray[i][7];
            } else{
                markerUrl = '/wp-content/themes/classy/dist/img/dealers/map/dealers-marker.png';
            }
            marker = new google.maps.Marker({
                position: new google.maps.LatLng(pointsArray[i][1], pointsArray[i][2]),
                map: map,
                icon: {
                    url: markerUrl
                }
            });
            if(pointsArray[i][0]) {
                google.maps.event.addListener(marker, 'click', (function(marker, i) {

                    return function () {
                        infowindow.setContent(
                            '<div class="google-map-info">' +
                            '<div class="google-map-info__image">' +
                            '<img src="'+pointsArray[i][4]+'" alt="">' +
                            '</div>' +
                            '<div class="google-map-info__title">'+pointsArray[i][3]+'</div>' +
                            '<div class="google-map-info__contacts">' +
                            '<span>'+pointsArray[i][5]+'</span>' +
                            '<span>'+pointsArray[i][6]+'</span>' +
                            '<span></span>' +
                            '</div>' +
                            '</div>'
                        );
                        infowindow.open(map, marker);
                    }

                })(marker, i));
            }
        }
    };

    google.maps.event.addDomListener(window, 'load', init);
};

export default dealersMap;